<div class="min-h-screen w-full flex items-center justify-center bg-surface dark:bg-surface-dim px-4">
  <div class="w-full max-w-sm bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl shadow-lg p-8 flex flex-col items-center gap-6">
    <div class="flex flex-col items-center gap-2">
      <img src="traxtion-logo.jpg" alt="TraXtion" class="h-10 w-auto mx-auto" />
      <p class="text-text-muted dark:text-on-surface-variant font-body-sm text-body-sm">Field Service Management</p>
    </div>

    <button (click)="signIn()"
            class="w-full h-[44px] flex items-center justify-center gap-3 rounded-lg border border-border-subtle dark:border-outline-variant bg-white hover:bg-surface-variant transition-colors font-label-md text-[#1b1b1b]">
      <svg width="20" height="20" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
        <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
        <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
      </svg>
      Sign in with Microsoft
    </button>

    <p class="text-text-muted dark:text-on-surface-variant text-xs text-center">
      Use your TraXtion organizational account. Contact your administrator if you don't have access yet.
    </p>
  </div>
</div>
